import { NoReportsIllustration } from "vega-illustrations";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { Card } from "@vega-core/components/shadcn/card";
import { m } from "@vega-core/paraglide/messages";

type AnalyticsCardErrorProps = {
  onRefresh?: () => void;
  dataTestId?: string;
};

export function AnalyticsCardError({
  onRefresh,
  dataTestId,
}: AnalyticsCardErrorProps) {
  return (
    <Card
      className="flex flex-col items-center justify-center gap-4 p-6 w-full min-h-72"
      data-testid={dataTestId}
    >
      <div className="flex justify-center">
        <NoReportsIllustration />
      </div>
      <div className="text-center">
        <div className="body-base-semibold text-text/primary">
          {m.analytics_error_dataTemporarilyUnavailable()}
        </div>
        <div className="body-base-regular text-text/secondary">
          {m.analytics_error_pleaseTryAgainLater()}{" "}
          {onRefresh ? (
            <ThemedButton
              dataTestId="analytics-card-refresh-button"
              onClick={onRefresh}
              variant="text"
            >
              {m.common_refresh()}
            </ThemedButton>
          ) : (
            m.common_refresh()
          )}{" "}
          {m.analytics_error_orTryAgainLater()}
        </div>
      </div>
    </Card>
  );
}
